import "@fancyapps/ui/dist/fancybox.css";
import { Fancybox } from "@fancyapps/ui";

export default Fancybox;
